/* -------------------------------------------------------------------------- */
/*                      Create short text ending with ...                     */
/* -------------------------------------------------------------------------- */
export function longTextToShortText(text: string, maxLength: number): string {
  return text?.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}
